import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NavRootPage } from './nav-root';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    NavRootPage,
  ],
  imports: [
    IonicPageModule.forChild(NavRootPage),
    DirectivesModule,
  ],
})
export class NavRootPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-root/nav-root.module.ts